require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-medicinenet-symptoms.json") })
        }
      }, "path---article-medicinenet-symptoms");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-medicinenet-symptoms!./.cache/json/article-medicinenet-symptoms.json
// module id = 359
// module chunks = 231608221292675